import { render } from "./Reports.svg?vue&type=template&id=3e7b10f3"
const script = {}
script.render = render

export default script